import React, { useState } from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import MultipleAccountsIcon from '../Assets/SVG/multipleAccountsIcon';
import { lobbySelection } from '../Assets/variables';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import '../../../Shared/RadioInput/RadioInput.scss';
const ChooseLobby = (props) => {
  const [isError, setError] = useState(null);
  const [selectedLobby, setLobby] = useState(null);

  const continueToLobby = () => {
    if (selectedLobby) {
      props.onclick(selectedLobby);
    } else {
      setError('אנא בחר משתמש');
    }
  };

  return (
    <div className='screenContainer'>
      <MultipleAccountsIcon />
      <h3 className='heading'>לאיזה חשבון להתחבר?</h3>
      <div className='radio-input-container'>
        <RadioInput
          checked={selectedLobby === lobbySelection.PRIVATE}
          onChange={() => {
            setLobby(lobbySelection.PRIVATE);
          }}
          label={'חשבון פרטי'}
          name='SelectedLobby'
          value={lobbySelection.PRIVATE}
          id='privateLobbySelection'
        />
        <RadioInput
          checked={selectedLobby === lobbySelection.BUSINESS}
          onChange={() => setLobby(lobbySelection.BUSINESS)}
          label={'חשבון עסקי'}
          name='SelectedLobby'
          value={lobbySelection.BUSINESS}
          id='businessLobbySelection'
        />
      </div>

      <Footer onclick={continueToLobby} stage={props.stage} />
    </div>
  );
};

export default ChooseLobby;
